import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import HighlightService from './HighlightService'

export const getRiskScaleInterpretationThunk = createAsyncThunk(
  'industryAnalysis/getRiskScaleInterpretationThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await HighlightService.getRiskScaleInterpretation(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getIndustryMedianRiskScoreThunk = createAsyncThunk(
  'industryAnalysis/getIndustryMedianRiskScoreThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await HighlightService.getIndustryMedianRiskScore(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const financialRatioHighlightThunk = createAsyncThunk(
  'industryAnalysis/financialRatioHighlightThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await HighlightService.financialRatioHighlight(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
